/** @format */

/**
 * 数值区间筛选项：标签 + 起止两个 Input（失焦时提交）。
 * 用于会话分析侧栏，样式与 FilterItem 单行布局对齐。
 */

import React from 'react'
import { _$, Input } from '@king-design/react'
import styled from 'styled-components'
import { FilterRangeValueProps } from '../../SessionAnalysis/typescript'

function asNum(v: string): number {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

export interface FilterRangeItemProps {
  className?: string
  label: string
  start: number | null
  end: number | null
  suffix?: string
  onChange: (key: string, patch: Partial<Pick<FilterRangeValueProps, 'Start' | 'End'>>) => void
  fieldKey: string
}

const FilterRangeItem: React.FC<FilterRangeItemProps> = ({
  className,
  label,
  start,
  end,
  suffix,
  onChange,
  fieldKey
}) => (
  <div className={className}>
    <span className="session_filter_label session_filter_label_range">{label}：</span>
    <div className="session_filter_range">
      <Input
        type="number"
        className="session_filter_range_input"
        value={start ?? ''}
        clearable
        placeholder={`${_$('请输入起始值')} `}
        onBlur={e => {
          const v = (e.target as HTMLInputElement).value
          onChange(fieldKey, { Start: v ? asNum(v) : null })
        }}
        slotSuffix={suffix ? <span className="range-suffix">{suffix}</span> : undefined}
      />
      <span className="range-sep">-</span>
      <Input
        type="number"
        className="session_filter_range_input"
        value={end ?? ''}
        clearable
        placeholder={`${_$('请输入结束值')}`}
        onBlur={e => {
          const v = (e.target as HTMLInputElement).value
          onChange(fieldKey, { End: v ? asNum(v) : null })
        }}
        slotSuffix={suffix ? <span className="range-suffix">{suffix}</span> : undefined}
      />
    </div>
  </div>
)

export default styled(FilterRangeItem)`
  display: flex;
  align-items: stretch;
  width: 100%;
  min-width: 0;

  .session_filter_label {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    min-width: 72px;
    max-width: 120px;
    padding: 0 8px;
    font-size: 12px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .session_filter_range {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 8px;

    .session_filter_range_input {
      flex: 1;
      min-width: 0;
    }

    .range-sep {
      flex-shrink: 0;
      color: var(--k-text-placeholder-color, rgba(0, 0, 0, 0.45));
    }

    .range-suffix {
      padding-right: 8px;
      color: var(--k-text-placeholder-color, rgba(0, 0, 0, 0.45));
      font-size: 12px;
    }
  }
`
